import type { CSSProperties } from 'react'
import MarkdownRenderer from '@/components/common/MarkdownRenderer'

interface ProseRendererProps {
  content?: string | null
  className?: string
  style?: CSSProperties
  /** 作品语言 (content_language); 用于 :lang() 脚本字体匹配 + 阿语 RTL 方向。 */
  lang?: string
}

// 从右向左书写的脚本 (目前内容语言集中仅阿拉伯语)。
const RTL_LANGS = new Set(['ar'])

export function ProseRenderer({ content, className, style, lang }: ProseRendererProps) {
  const baseLang = lang?.toLowerCase().split('-')[0]
  const dir = baseLang && RTL_LANGS.has(baseLang) ? 'rtl' : undefined
  return (
    <div className={className} lang={baseLang || undefined} dir={dir}>
      <style>
        {`
          .nf-reader-prose .nf-markdown {
            line-height: 1.8;
            letter-spacing: 0;
          }
          .nf-reader-prose .nf-markdown p {
            margin: 0 0 1.05em;
            text-indent: 2em;
          }
          .nf-reader-prose .nf-markdown blockquote p,
          .nf-reader-prose .nf-markdown li p,
          .nf-reader-prose .nf-markdown td p {
            text-indent: 0;
          }
          .nf-reader-prose .nf-markdown h1,
          .nf-reader-prose .nf-markdown h2,
          .nf-reader-prose .nf-markdown h3 {
            border-bottom: 0;
            font-weight: 700;
            text-indent: 0;
          }
          .nf-reader-prose .nf-markdown img {
            margin-right: auto;
            margin-left: auto;
          }
        `}
      </style>
      <MarkdownRenderer content={content} className="nf-reader-prose" style={style} />
    </div>
  )
}
